module.exports = __webpack_public_path__ + "static/img/hospital2Pic1.a174957a.png";